<template>
  <DialogQRFail ref="QRFail" fail-title="読み込みがうまくいきませんでした" />
</template>

<script>
export default {
  name: "TemplateSTR",
  methods: {
    // ストアの場合はIDのチケット詳細を開くだけ。別WebviewなのでopenTicket()
    async STR() {
      const id = this.$route.query.master_book_id;
      try {
        if (this.ENV === "local") {
          this.$router.push({
            name: "MasterBook",
            params: { id: id },
            query: {
              fromQR: true,
              language: this.$store.getters["common/lang"],
            },
          });
        } else {
          this.openTicket(
            `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}ticket-store/ticketing/master-book/${id}?fromQR=true`
          );
        }
      } catch (err) {
        this.$refs.QRFail.openDialog();
      }
    },
  },
};
</script>
